export const FIELD_SEARCH_LABELS = Object.freeze({
  name: "Название",
  city: "Город",
  category: "Тип объекта",
  status: "Статус ЖК",
  developer: "Застройщик",
  location: "Расположение",
  metro: "Метро",
  currentClientId: "Текущий клиент",
  sip_number: "СИП-номер",
  transfer_number: "Номер перевода",
  cityCategory: "Город / область",
  preset: "Форма метки",
});

export const FIELD_SEARCH_OPERATOR_LABELS = Object.freeze({
  contains: "Содержит",
  equals: "Равно",
  "not equals": "Не равно",
  exists: "Поле существует",
  empty: "Пустое поле",
});

export const FIELD_SEARCH_FIELDS = Object.keys(FIELD_SEARCH_LABELS);
export const FIELD_SEARCH_OPERATORS = Object.keys(FIELD_SEARCH_OPERATOR_LABELS);

let fieldFilterSequence = 0;

export function createFieldFilter(values = {}) {
  fieldFilterSequence += 1;
  const field = FIELD_SEARCH_FIELDS.includes(values.field) ? values.field : "";
  const requestedOperator = FIELD_SEARCH_OPERATORS.includes(values.operator) ? values.operator : "contains";
  return {
    id: String(values.id || `field-filter-${Date.now()}-${fieldFilterSequence}`),
    field,
    operator: field === "status" && requestedOperator === "contains" ? "equals" : requestedOperator,
    value: values.value == null ? "" : String(values.value),
  };
}

export function normalizeFieldFilters(filters, legacyFilters = null) {
  const source = Array.isArray(filters)
    ? filters
    : legacyFilters?.field
      ? [{
          field: legacyFilters.field,
          operator: legacyFilters.operator,
          value: legacyFilters.value,
        }]
      : [];

  const normalized = source
    .filter((item) => isPlainObject(item) && FIELD_SEARCH_FIELDS.includes(item.field))
    .map((item) => createFieldFilter(item));

  return normalized.length > 0 ? normalized : [createFieldFilter()];
}

export function getActiveFieldFilters(filters) {
  return (Array.isArray(filters) ? filters : [])
    .filter((item) => {
      if (!FIELD_SEARCH_FIELDS.includes(item?.field)) return false;
      if (!FIELD_SEARCH_OPERATORS.includes(item?.operator)) return false;
      return ["exists", "empty"].includes(item.operator) || String(item.value || "").trim().length >= 3;
    })
    .map(({ field, operator, value }) => ({ field, operator, value: String(value || "").trim() }));
}

export function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function validateJsonQuery(query) {
  for (const [field, condition] of Object.entries(query)) {
    if (!FIELD_SEARCH_FIELDS.includes(field)) return `Неподдерживаемое поле: ${field}`;
    if (!isPlainObject(condition)) continue;

    for (const operator of Object.keys(condition)) {
      if (!["$regex", "$options", "$exists", "$eq", "$ne"].includes(operator)) {
        return `Неподдерживаемое условие ${operator} для поля ${field}`;
      }
    }

    if ("$regex" in condition) {
      try {
        new RegExp(String(condition.$regex), condition.$options || "");
      } catch (regexError) {
        return regexError instanceof Error ? regexError.message : `Некорректное выражение в поле ${field}`;
      }
    }
  }

  return "";
}

export function parseJsonQuery(value) {
  const trimmedValue = value.trim();
  if (!trimmedValue) return { query: null, error: "" };

  try {
    const parsed = JSON.parse(trimmedValue);
    if (!isPlainObject(parsed)) return { query: null, error: "JSON-запрос должен быть объектом" };
    const validationError = validateJsonQuery(parsed);
    return validationError ? { query: null, error: validationError } : { query: parsed, error: "" };
  } catch (error) {
    return { query: null, error: error instanceof Error ? error.message : "Некорректный JSON-запрос" };
  }
}

export function buildSearchFilter({ category, status, jsonQuery }) {
  const filter = jsonQuery ? { ...jsonQuery } : {};
  if (category) filter.category = category;
  if (status === "active") filter.status = true;
  if (status === "stopped") filter.status = false;
  return filter;
}
